import { request } from '@/utils/request';

const urls = {
  // 查询指定机构岗位列表接口
  positionList: '/api/workbench/positionManager/pagingPosition4Org',
  // 新增岗位
  positionCreate: '/api/workbench/posts/create',
  // 更新岗位
  positionUpdate: '/api/workbench/posts',
  // 重命名岗位
  positionRename: '/api/workbench/posts/rename',
  // 删除岗位
  positionDelete: '/api/workbench/posts',
  // 批量更新岗位状态 禁用批量
  positionUpdateStatus: '/api/workbench/posts/updateStatus',
  // 获取岗位功能树
  positionRoleGroup: '/api/workbench/privileges/position/tree',
  positionDetail: '/api/workbench/positionManager/getDetail',
  positionPersonnels: '/api/workbench/positionManager/personnels',
  // 分页获取添加人员列表
  pagingPersonals: '/api/workbench/positionManager/pagingPersonnel',
  // 获取岗位关联人员
  operatorListByPositionWithPagination: '/api/workbench/userCategories/getOperatorListByPosition',
  // 获取岗位关联人员
  operatorListByPosition: '/api/workbench/userCategories/getOperatorByPosition',
  treeDepartPersonnels: '/api/zlbuser/institution/treeDepartPersonnels',
  // treeDepartPersonnels: 'http://yapi.cai-inc.com/mock/3005/api/user/institution/treeDepartPersonnels',
  institutionPersonnels: '/api/zlbuser/institution/personnels',
  // institutionPersonnels: 'http://yapi.cai-inc.com/mock/3005/api/user/institution/personnels',
  // 添加和删除人员
  optRole: '/api/workbench/positionManager/optRole',
};

// 岗位管理相关接口
export async function reqPositionManagerList (params) {
  return request(urls.positionList, {
    params,
  });
}

// 获取个人岗位详情
export async function reqPositionDetail (params) {
  return request(urls.positionDetail, {
    params,
  });
}

export async function reqPositionManagerPersonals (params) {
  return request(urls.positionPersonnels, {
    params,
  });
}

// 分页获取添加人员列表
export async function reqPagingPersonals (params) {
  return request(urls.pagingPersonals, {
    params,
  });
}

// 获取功能权限节点
export async function reqRoleTree (params) {
  return request(urls.positionRoleGroup, {
    params,
  });
}

// 获取岗位对应操作人
export async function reqOperatorListByPosition (data) {
  return request(urls.operatorListByPosition, {
    method: 'post',
    data,
  });
}
// 获取岗位对应操作人
export async function reqOperatorListByPositionWithPagination (params) {
  return request(urls.operatorListByPositionWithPagination, {
    params,
  });
}


//
export async function reqTreeDepartPersonnels (params) {
  return request(urls.treeDepartPersonnels, {
    params,
  });
}

// 机构下人员
export async function reqInstitutionPersonnels (params) {
  return request(urls.institutionPersonnels, {
    params,
  });
}

export async function reqPositionManagerCreate (params) {
  return request(urls.positionCreate, {
    method: 'post',
    data: params,
  });
}

// 添加/删除人员
export async function reqOptRole (params) {
  return request(urls.optRole, {
    method: 'post',
    data: params,
  });
}

export async function reqPositionManagerUpdate (params) {
  const { postId, ...rest } = params;
  return request(`${urls.positionUpdate}/${postId}/update`, {
    method: 'post',
    data: rest,
  });
}

export async function reqPositionManagerUpdateStatus (params) {
  return request(urls.positionUpdateStatus, {
    method: 'post',
    data: params,
  });
}

export async function reqPositionManagerRename (params) {
  const { postId, ...rest } = params;
  return request(`${urls.positionRename}/${postId}`, {
    method: 'post',
    data: rest,
  });
}

export async function reqPositionManagerDelete (data) {
  return request('/api/workbench/posts/delete', {
    method: 'post',
    data,
  });
}

